export const videos = [
  {
    id: "v1001",
    title: "爆笑街头采访合集：路人的神回复",
    description:
      "把镜头对准街头，随机采访路人对各种脑洞问题的真实回答。有人一本正经地胡说八道，也有人机智反击让人笑到停不下来。本期精选三天拍摄的高能名场面，全程无尿点。",
    category: "comedy",
    tags: ["街头采访", "神回复", "合集"],
    duration: "12:38",
    views: 1842000,
    uploadDate: "2026-09-28",
    videoUrl: "",
    featured: true,
    cover:
      "https://readdy.ai/api/search-image?query=Bright%20cheerful%20outdoor%20city%20street%20scene%20with%20a%20film%20crew%20interviewing%20passersby%2C%20warm%20sunny%20afternoon%20light%2C%20lively%20energetic%20atmosphere%2C%20soft%20orange%20tones%2C%20clean%20composition%2C%20modern%20editorial%20photography%20rounded%20shapes&width=640&height=360&seq=yt-comedy-01&orientation=landscape",
  },
  {
    id: "v1002",
    title: "办公室搞笑日常：摸鱼的一百种方式",
    description:
      "打工人的快乐其实很简单。从早会假装认真到午休抢零食，这一段办公室短剧用夸张的表演还原了每个职场人都经历过的瞬间，笑点密集又真实。",
    category: "comedy",
    tags: ["短剧", "职场", "爆笑"],
    duration: "08:15",
    views: 963400,
    uploadDate: "2026-09-22",
    videoUrl: "",
    featured: false,
    cover:
      "https://readdy.ai/api/search-image?query=Modern%20bright%20office%20interior%20with%20playful%20colleagues%20acting%20silly%2C%20warm%20wooden%20furniture%2C%20soft%20daylight%20from%20large%20windows%2C%20cheerful%20humorous%20mood%2C%20clean%20minimal%20aesthetic%2C%20warm%20orange%20accent%20tones&width=640&height=360&seq=yt-comedy-02&orientation=landscape",
  },
  {
    id: "v1003",
    title: "年度沙雕新闻盘点：离谱事件大合集",
    description:
      "一年一度的沙雕新闻大盘点回来了。从匪夷所思的巧合到让人哭笑不得的操作，我们用轻松的方式带你回顾那些真实发生过的离谱事件。",
    category: "comedy",
    tags: ["盘点", "新闻", "搞笑"],
    duration: "15:42",
    views: 1218000,
    uploadDate: "2026-09-15",
    videoUrl: "",
    featured: false,
    cover:
      "https://readdy.ai/api/search-image?query=Playful%20colorful%20flat%20lay%20of%20newspapers%20and%20props%20on%20a%20warm%20wooden%20table%2C%20bright%20studio%20lighting%2C%20cheerful%20quirky%20mood%2C%20orange%20and%20yellow%20accents%2C%20clean%20minimal%20composition%2C%20editorial%20photography%20style&width=640&height=360&seq=yt-comedy-03&orientation=landscape",
  },
  {
    id: "v1004",
    title: "深海秘境探索：黑暗中的发光生命",
    description:
      "跟随深海探测器下潜到三千米的黑暗世界，记录那些会发光的奇异生物与热泉生态。每一帧画面都来自真实的深海科考影像，带你看见另一个星球般的海底。",
    category: "documentary",
    tags: ["海洋", "自然", "科学"],
    duration: "42:07",
    views: 786500,
    uploadDate: "2026-09-30",
    videoUrl: "",
    featured: true,
    cover:
      "https://readdy.ai/api/search-image?query=Deep%20ocean%20underwater%20scene%20with%20glowing%20bioluminescent%20creatures%20and%20dark%20blue%20water%2C%20mysterious%20cinematic%20atmosphere%2C%20soft%20teal%20and%20warm%20amber%20highlights%2C%20documentary%20photography%2C%20high%20detail%20elegant%20composition&width=640&height=360&seq=yt-doc-01&orientation=landscape",
  },
  {
    id: "v1005",
    title: "城市变迁三十年：一条街的记忆",
    description:
      "用三十年的影像资料，讲述一条老街从青砖瓦房到高楼林立的完整变化。片中采访了几代居民，听他们讲述属于这座城市的共同记忆。",
    category: "documentary",
    tags: ["人文", "城市", "影像"],
    duration: "36:20",
    views: 421300,
    uploadDate: "2026-09-12",
    videoUrl: "",
    featured: false,
    cover:
      "https://readdy.ai/api/search-image?query=Nostalgic%20old%20city%20street%20with%20mid%20century%20buildings%20blending%20into%20modern%20skyline%2C%20warm%20golden%20hour%20light%2C%20reflective%20calm%20mood%2C%20soft%20sepia%20and%20orange%20tones%2C%20documentary%20photography%2C%20wide%20elegant%20composition&width=640&height=360&seq=yt-doc-02&orientation=landscape",
  },
  {
    id: "v1006",
    title: "极地生命纪实：冰原上的春天",
    description:
      "在极寒之地，生命依然顽强。本片记录了极地动物在短暂夏季里的繁衍生息，从候鸟迁徙到幼崽学步，每一个镜头都弥足珍贵。",
    category: "documentary",
    tags: ["自然", "极地", "动物"],
    duration: "48:55",
    views: 654200,
    uploadDate: "2026-09-06",
    videoUrl: "",
    featured: false,
    cover:
      "https://readdy.ai/api/search-image?query=Vast%20icy%20polar%20landscape%20with%20distant%20wildlife%20and%20soft%20morning%20light%2C%20serene%20majestic%20mood%2C%20cool%20white%20and%20warm%20horizon%20glow%2C%20clean%20minimal%20documentary%20photography%2C%20high%20detail%20panoramic%20composition&width=640&height=360&seq=yt-doc-03&orientation=landscape",
  },
  {
    id: "v1007",
    title: "夏日民谣现场：一把吉他的午后",
    description:
      "在洒满阳光的露台上，几位民谣歌手带来了一场即兴的午后演出。简单的和弦、真诚的嗓音，适合安静地听完整场，让时间慢下来。",
    category: "music",
    tags: ["民谣", "现场", "治愈"],
    duration: "52:14",
    views: 528700,
    uploadDate: "2026-09-26",
    videoUrl: "",
    featured: true,
    cover:
      "https://readdy.ai/api/search-image?query=Cozy%20sunlit%20rooftop%20terrace%20folk%20music%20performance%20with%20a%20guitarist%20and%20a%20small%20audience%2C%20warm%20afternoon%20light%2C%20intimate%20relaxed%20atmosphere%2C%20soft%20orange%20and%20cream%20tones%2C%20editorial%20photography&width=640&height=360&seq=yt-music-01&orientation=landscape",
  },
  {
    id: "v1008",
    title: "城市电音派对：霓虹之夜全程",
    description:
      "整晚不间断的电子音乐现场，来自不同城市的 DJ 轮番登场。霓虹灯下的节拍与人群的呐喊交织，戴上耳机就能感受现场的能量。",
    category: "music",
    tags: ["电音", "派对", "现场"],
    duration: "1:18:40",
    views: 892100,
    uploadDate: "2026-09-18",
    videoUrl: "",
    featured: false,
    cover:
      "https://readdy.ai/api/search-image?query=Vibrant%20urban%20electronic%20music%20party%20with%20colorful%20neon%20lights%20and%20a%20energetic%20crowd%2C%20warm%20orange%20and%20magenta%20glow%2C%20dynamic%20nightlife%20atmosphere%2C%20cinematic%20photography%2C%20clean%20elegant%20composition&width=640&height=360&seq=yt-music-02&orientation=landscape",
  },
  {
    id: "v1009",
    title: "古典钢琴独奏会：月光之下",
    description:
      "一场安静的古典钢琴独奏会，演奏了多首经典曲目。柔和的灯光与细腻的触键相得益彰，适合在夜晚戴上耳机慢慢欣赏。",
    category: "music",
    tags: ["古典", "钢琴", "独奏"],
    duration: "58:32",
    views: 317600,
    uploadDate: "2026-09-09",
    videoUrl: "",
    featured: false,
    cover:
      "https://readdy.ai/api/search-image?query=Elegant%20classical%20piano%20recital%20stage%20with%20a%20grand%20piano%20under%20warm%20soft%20spotlight%2C%20refined%20calm%20atmosphere%2C%20deep%20brown%20and%20amber%20tones%2C%20high%20end%20editorial%20photography%2C%20minimal%20elegant%20composition&width=640&height=360&seq=yt-music-03&orientation=landscape",
  },
  {
    id: "v1010",
    title: "综艺爆笑名场面：笑到捧腹的瞬间",
    description:
      "精选近期热门综艺里的爆笑片段，嘉宾们的临场反应和游戏环节全程高能。一集看完，心情 instantly 变好。",
    category: "entertainment",
    tags: ["综艺", "爆笑", "合集"],
    duration: "22:48",
    views: 1476000,
    uploadDate: "2026-10-01",
    videoUrl: "",
    featured: true,
    cover:
      "https://readdy.ai/api/search-image?query=Bright%20colorful%20tv%20variety%20show%20studio%20set%20with%20playful%20props%20and%20cheerful%20hosts%2C%20vivid%20warm%20lighting%2C%20fun%20energetic%20mood%2C%20orange%20and%20yellow%20accents%2C%20clean%20modern%20editorial%20photography&width=640&height=360&seq=yt-ent-01&orientation=landscape",
  },
  {
    id: "v1011",
    title: "明星访谈精选：镜头之外的真心话",
    description:
      "邀请多位演员与歌手，聊聊他们镜头之外的生活与坚持。没有剧本，只有真诚的对话，每一段都值得慢慢听完。",
    category: "entertainment",
    tags: ["访谈", "人物", "精选"],
    duration: "28:06",
    views: 356900,
    uploadDate: "2026-09-20",
    videoUrl: "",
    featured: false,
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20intimate%20studio%20interview%20setting%20with%20two%20soft%20armchairs%20and%20a%20low%20table%2C%20warm%20amber%20lighting%2C%20calm%20thoughtful%20atmosphere%2C%20cream%20and%20orange%20tones%2C%20editorial%20photography%2C%20minimal%20composition&width=640&height=360&seq=yt-ent-02&orientation=landscape",
  },
  {
    id: "v1012",
    title: "舞台高光时刻：燃到起鸡皮疙瘩",
    description:
      "把一年中最炸裂的舞台表演剪成一支合集。灯光、音乐与舞台调度完美配合，每一个高光瞬间都让人忍不住回看。",
    category: "entertainment",
    tags: ["舞台", "高光", "合集"],
    duration: "19:33",
    views: 733500,
    uploadDate: "2026-09-11",
    videoUrl: "",
    featured: false,
    cover:
      "https://readdy.ai/api/search-image?query=Stunning%20live%20stage%20performance%20with%20dramatic%20warm%20spotlights%20and%20a%20performer%20silhouette%2C%20epic%20energetic%20atmosphere%2C%20orange%20and%20gold%20glow%2C%20cinematic%20concert%20photography%2C%20clean%20powerful%20composition&width=640&height=360&seq=yt-ent-03&orientation=landscape",
  },
  {
    id: "v1013",
    title: "悬疑短片精选：三分钟的烧脑反转",
    description:
      "每支短片都在三分钟内完成一次漂亮的悬念与反转。精巧的叙事节奏和意外结局，让你在短时间内体验完整的情绪过山车。",
    category: "movie",
    tags: ["悬疑", "短片", "反转"],
    duration: "24:50",
    views: 612800,
    uploadDate: "2026-09-29",
    videoUrl: "",
    featured: false,
    cover:
      "https://readdy.ai/api/search-image?query=Moody%20cinematic%20film%20still%20with%20dramatic%20warm%20shadows%20and%20a%20lone%20figure%20in%20an%20empty%20room%2C%20suspenseful%20atmosphere%2C%20amber%20and%20deep%20brown%20tones%2C%20high%20contrast%20editorial%20photography%2C%20artistic%20composition&width=640&height=360&seq=yt-movie-01&orientation=landscape",
  },
  {
    id: "v1014",
    title: "经典片段回顾：那些难忘的画面",
    description:
      "重温影史中那些被反复提起的经典片段。从台词到镜头语言，我们简单聊聊它们为什么能成为一代人的共同记忆。",
    category: "movie",
    tags: ["经典", "回顾", "影史"],
    duration: "31:17",
    views: 489200,
    uploadDate: "2026-09-14",
    videoUrl: "",
    featured: false,
    cover:
      "https://readdy.ai/api/search-image?query=Retro%20cinema%20interior%20with%20a%20large%20warm%20lit%20screen%20and%20rows%20of%20red%20seats%2C%20nostalgic%20cozy%20mood%2C%20deep%20amber%20and%20crimson%20tones%2C%20cinematic%20photography%2C%20elegant%20symmetrical%20composition&width=640&height=360&seq=yt-movie-02&orientation=landscape",
  },
  {
    id: "v1015",
    title: "独立电影推荐：小成本大惊喜",
    description:
      "一批制作成本不高但口碑极佳的独立电影推荐。它们或许没有大场面，却用真诚的故事和独特的视角打动了无数观众。",
    category: "movie",
    tags: ["独立电影", "推荐", "文艺"],
    duration: "27:44",
    views: 298300,
    uploadDate: "2026-09-04",
    videoUrl: "",
    featured: false,
    cover:
      "https://readdy.ai/api/search-image?query=Artistic%20indie%20film%20scene%20with%20soft%20window%20light%20and%20a%20thoughtful%20character%2C%20warm%20muted%20tones%2C%20quiet%20emotional%20atmosphere%2C%20cream%20and%20amber%20palette%2C%20award%20winning%20cinematography%20style&width=640&height=360&seq=yt-movie-03&orientation=landscape",
  },
  {
    id: "v1016",
    title: "未来科技趋势解析：下一个十年",
    description:
      "用通俗的语言梳理未来十年最值得关注的科技趋势。从人工智能到新能源，带你看懂这些变化会如何影响日常生活。",
    category: "tech",
    tags: ["趋势", "人工智能", "解析"],
    duration: "18:22",
    views: 812600,
    uploadDate: "2026-09-27",
    videoUrl: "",
    featured: false,
    cover:
      "https://readdy.ai/api/search-image?query=Futuristic%20technology%20concept%20scene%20with%20glowing%20circuits%20and%20clean%20devices%20on%20a%20warm%20surface%2C%20modern%20optimistic%20mood%2C%20amber%20and%20orange%20accents%2C%20high%20detail%20editorial%20photography%2C%20minimal%20composition&width=640&height=360&seq=yt-tech-01&orientation=landscape",
  },
  {
    id: "v1017",
    title: "智能生活体验：一次彻底的改造",
    description:
      "把一间普通公寓改造成全屋智能空间，从灯光、窗帘到家电联动，完整记录改造过程与实际使用感受，看看科技如何融入日常。",
    category: "tech",
    tags: ["智能家居", "体验", "改造"],
    duration: "21:58",
    views: 445700,
    uploadDate: "2026-09-17",
    videoUrl: "",
    featured: false,
    cover:
      "https://readdy.ai/api/search-image?query=Modern%20minimal%20smart%20home%20living%20room%20with%20ambient%20warm%20lighting%20and%20subtle%20tech%20devices%2C%20cozy%20futuristic%20mood%2C%20cream%20and%20amber%20tones%2C%20architectural%20interior%20photography%2C%20clean%20elegant%20composition&width=640&height=360&seq=yt-tech-02&orientation=landscape",
  },
  {
    id: "v1018",
    title: "探秘机器人实验室：会走路的未来",
    description:
      "走进机器人实验室，近距离观察那些正在学习行走与抓取的机器。研究团队分享了背后的技术挑战，也展示了令人惊叹的最新成果。",
    category: "tech",
    tags: ["机器人", "探秘", "实验室"],
    duration: "25:36",
    views: 573400,
    uploadDate: "2026-09-08",
    videoUrl: "",
    featured: false,
    cover:
      "https://readdy.ai/api/search-image?query=Clean%20high%20tech%20robotics%20laboratory%20with%20a%20sleek%20robot%20and%20engineers%2C%20bright%20warm%20lighting%2C%20innovative%20curious%20mood%2C%20orange%20accent%20details%2C%20modern%20editorial%20photography%2C%20minimal%20composition&width=640&height=360&seq=yt-tech-03&orientation=landscape",
  },
  {
    id: "v1019",
    title: "家常菜教学合集：零失败的下饭菜",
    description:
      "精选几道最容易上手的家常菜，步骤清晰、用料简单。跟着做几乎不会失败，非常适合刚开始学做饭的朋友收藏。",
    category: "life",
    tags: ["美食", "教学", "家常菜"],
    duration: "33:12",
    views: 1093000,
    uploadDate: "2026-09-25",
    videoUrl: "",
    featured: false,
    cover:
      "https://readdy.ai/api/search-image?query=Appetizing%20home%20cooked%20dishes%20on%20a%20warm%20wooden%20table%20with%20fresh%20ingredients%20nearby%2C%20cozy%20kitchen%20lighting%2C%20delicious%20inviting%20mood%2C%20orange%20and%20cream%20tones%2C%20food%20editorial%20photography&width=640&height=360&seq=yt-life-01&orientation=landscape",
  },
  {
    id: "v1020",
    title: "旅行风景漫步：慢下来看一座城",
    description:
      "没有匆忙的打卡行程，只是慢慢地走过一座城市的街巷与河岸。记录清晨的市集、傍晚的天台，以及路上遇到的那些温柔瞬间。",
    category: "life",
    tags: ["旅行", "风景", "慢生活"],
    duration: "40:08",
    views: 397800,
    uploadDate: "2026-09-16",
    videoUrl: "",
    featured: false,
    cover:
      "https://readdy.ai/api/search-image?query=Peaceful%20travel%20scene%20of%20a%20charming%20old%20town%20street%20at%20golden%20hour%2C%20warm%20soft%20light%2C%20relaxed%20wanderlust%20mood%2C%20amber%20and%20terracotta%20tones%2C%20editorial%20travel%20photography%2C%20elegant%20composition&width=640&height=360&seq=yt-life-02&orientation=landscape",
  },
  {
    id: "v1021",
    title: "收纳整理小技巧：让家一秒变整齐",
    description:
      "分享一些实用又不费钱的收纳方法，从衣柜到厨房，用简单的思路把杂乱变成有序，让每天回家的心情都更好一点。",
    category: "life",
    tags: ["收纳", "整理", "技巧"],
    duration: "16:45",
    views: 621500,
    uploadDate: "2026-09-05",
    videoUrl: "",
    featured: false,
    cover:
      "https://readdy.ai/api/search-image?query=Neat%20organized%20home%20shelves%20with%20folded%20linens%20and%20baskets%20in%20a%20bright%20warm%20room%2C%20calm%20tidy%20mood%2C%20cream%20and%20amber%20tones%2C%20minimal%20lifestyle%20photography%2C%20clean%20harmonious%20composition&width=640&height=360&seq=yt-life-03&orientation=landscape",
  },
  {
    id: "v1022",
    title: "篮球精彩集锦：本赛季最强进球",
    description:
      "盘点本赛季最不可思议的进球瞬间。压哨绝杀、隔人暴扣与背后妙传，每一个都值得反复回看，感受赛场上沸腾的肾上腺素。",
    category: "sports",
    tags: ["篮球", "集锦", "赛事"],
    duration: "14:29",
    views: 1348000,
    uploadDate: "2026-10-02",
    videoUrl: "",
    featured: true,
    cover:
      "https://readdy.ai/api/search-image?query=Dynamic%20basketball%20action%20scene%20in%20a%20warm%20lit%20arena%20with%20players%20mid%20jump%2C%20energetic%20exciting%20mood%2C%20orange%20court%20and%20amber%20highlights%2C%20sports%20editorial%20photography%2C%20clean%20powerful%20composition&width=640&height=360&seq=yt-sports-01&orientation=landscape",
  },
  {
    id: "v1023",
    title: "极限运动挑战：在山海之间飞驰",
    description:
      "滑翔、攀岩与山地速降，几位运动员用镜头记录了他们挑战极限的全过程。壮丽的自然风光与惊险的动作场面交织在一起。",
    category: "sports",
    tags: ["极限", "挑战", "户外"],
    duration: "29:53",
    views: 502700,
    uploadDate: "2026-09-19",
    videoUrl: "",
    featured: false,
    cover:
      "https://readdy.ai/api/search-image?query=Epic%20extreme%20sports%20scene%20with%20a%20paraglider%20above%20mountains%20and%20sea%20at%20sunset%2C%20adventurous%20thrilling%20mood%2C%20warm%20golden%20and%20orange%20tones%2C%20cinematic%20outdoor%20photography%2C%20sweeping%20composition&width=640&height=360&seq=yt-sports-02&orientation=landscape",
  },
  {
    id: "v1024",
    title: "足球经典进球：那些改写历史的瞬间",
    description:
      "重温足球历史上那些改变比赛走向的经典进球。从禁区外的世界波到补时阶段的绝杀，每一个都承载着一代球迷的记忆。",
    category: "sports",
    tags: ["足球", "经典", "进球"],
    duration: "17:36",
    views: 908900,
    uploadDate: "2026-09-10",
    videoUrl: "",
    featured: false,
    cover:
      "https://readdy.ai/api/search-image?query=Dramatic%20football%20match%20moment%20with%20a%20player%20striking%20the%20ball%20in%20a%20warm%20floodlit%20stadium%2C%20intense%20exciting%20mood%2C%20orange%20and%20amber%20highlights%2C%20sports%20editorial%20photography%2C%20clean%20dynamic%20composition&width=640&height=360&seq=yt-sports-03&orientation=landscape",
  },
];